import theme from '@app/ui/theme'
import { FaAngleRight } from 'react-icons/fa'
import styled, { keyframes } from 'styled-components'
import S from 'styled-components/native'

export const TotalText = styled.span`
  max-width: 100px;
  font-family: 'Proxima Nova';
  font-size: 20px;
`

export const TotalTextV2 = styled.span`
  font-family: 'Proxima Nova';
  font-size: 16px;
`

export const TotalValue = styled.span`
  font-family: 'Proxima Nova';
  font-size: 24px;
  font-weight: 600;
`
export const TotalValueV2 = styled.span`
  font-family: 'Proxima Nova';
  font-size: 24px;
  font-weight: 600;
`

export const AdmFactorGroupContainer = S.View`
    flex: 1;
    max-width: 900px;
    margin: 0 auto;
`

export const AdmFactorContainer = S.View`
    flex-direction: row;
    width: 100%;
    background-color: ${theme.colors.white};
    border: 1px solid ${theme.colors.dark2};
    border-radius: ${theme.borderRadius}px;
    padding: 16px;
    margin-bottom: 12px;
`

export const AdmFactorContainerV2 = S.View`
    width: 100%;
    background-color: ${theme.colors.white};
    border: 1px solid ${theme.colors.dark2};
    border-radius: ${theme.borderRadius}px;
    padding: 16px;
    margin-bottom: 12px;
`

export const AdmFactorCardGridV2 = styled.div<{
  lzCount: number
  showOr: boolean
  hasWideButtons?: boolean
}>`
  display: grid;
  grid-template-columns: ${({ lzCount, showOr, hasWideButtons }) =>
    `150px ${showOr ? '18px' : '0px'} repeat(${lzCount}, ${hasWideButtons ? '116px' : '72px'}) 1fr`};
  column-gap: 12px;
  row-gap: 8px;
  width: 100%;
  align-items: start;
  grid-auto-rows: min-content;
`

export const AdmFactorLeftCellV2 = styled.div`
  grid-column: 1;
  grid-row: 1 / -1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-self: start;
  gap: 2px;
`

export const AdmFactorOrCellV2 = styled.div`
  grid-column: 2;
  grid-row: 1 / -1;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const AdmFactorLzHeaderCellV2 = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const AdmFactorLzCellV2 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
`

export const AdmFactorTextCellV2 = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 8px 0;
`

export const AdmFactorHeaderRowV2 = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const AdmFactorTotalStackV2 = styled.div`
  display: flex;
  flex-direction: column;
  line-height: 1.1;
`

export const AdmFactorLabel = S.View`
    padding: 10px;
`

export const AdmFactorLabelContainer = S.View`
    width: 80px;
    height: 40px;
`

interface AdmFactorLabelBackgroundProps {
  collapsed: boolean
  expandable?: boolean
}

export const AdmFactorLabelBackground = S.View<AdmFactorLabelBackgroundProps>`
    background-color: ${(props) =>
      props.expandable ? theme.colors.primary : theme.colors.light2};
    width: 100%;
    height: 100%;
    border-radius: 50px;
    justify-content: center;
    align-items: flex-end;
    transform: rotate(${(props) => (props.collapsed ? 0 : 90)}deg);
    transition: all 0.3s ease;
`

export const AdmFactorLabelItem = S.View<{ automated?: boolean }>`
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    margin-top: -40px;
    cursor: default;
    position: relative;
`

export const AdmFactorLabelItemText = S.Text<{ expandable?: boolean }>`
    color: ${(props) =>
      props.expandable ? theme.colors.white : theme.colors.primary};
        font-weight: 600;
    font-size: 16px;
`

export const AdmFactorLabelIcon = styled(FaAngleRight)`
  color: rgba(255, 255, 255, 0.6);
  font-size: 13px;
  height: 40px;
  margin: 8px;
`

interface AdmFactorButtonsProps {
  collapsed?: boolean
  expandable?: boolean
}

export const AdmFactorButtons = S.View<AdmFactorButtonsProps>`
    flex: 1;
    max-height: ${(props) =>
      props.collapsed && props.expandable ? '140px' : '600px'};
    transition: 0.1s all ease;
    overflow: hidden;
`

export const AdmFactorButtonWrapper = S.View<{ isShotAdjustment?: boolean }>`
    flex-direction: ${({ isShotAdjustment }) =>
      isShotAdjustment ? 'column' : 'row'};
`

export const AdmFactorButton = S.View<{ wide?: boolean }>`
    width: ${({ wide }) => (wide ? '116px' : '70px')};
    height: 60px;
    padding: 8px;
`

export const AdmFactorTextWrapper = S.View`
    max-height: 200px;
    overflow: hidden;
    height: 100px;
    background-color: #999;
`

export const AdmFactorText = S.View`
    padding: 15px;
    flex-wrap: wrap;
    max-width: 600px;
`
export const AdmFactorTextV2 = S.View`
    padding: 15px;
    flex-wrap: wrap;
    max-width: 100%;
    width: 100%;
    flex-shrink: 1;
    align-self: stretch;
    overflow: hidden;
`

export const AdmFactorTextLabel = S.Text`
    font-size: 15px;
    font-family: 'Proxima Nova';
    flex-shrink: 1;
    width: 100%;
`

export const AdmFactorTextContainer = styled.div`
  font-size: 15px;
`

export const ButtonHeader = S.Text`
padding-right: 8px;
text-align: center;
`

const breatheAnimation = keyframes`
 0% { transform: rotate(0deg); }
 100% { transform: rotate(360deg); }
`
export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  animation-name: ${breatheAnimation};
  animation-duration: 4s;
  animation-iteration-count: infinite;
`
export const LoadingDefaultInputContainer = styled.div<{ isReadOnly: boolean }>`
  width: 60px;
  height: 36px;
  border: 1px solid ${({ theme }) => theme.colors.light3};
  background-color: ${({ theme, isReadOnly }) =>
    isReadOnly ? theme.colors.light4 : theme.colors.light3};
  border-radius: ${theme.borderRadius}px;
  border-color: ${({ theme }) => theme.colors.light4};
  display: flex;
  justify-content: center;
  align-items: center;
`

export const LoadingDefaultInputContainerV2 = styled.div<{
  isReadOnly: boolean
}>`
  width: 60px;
  height: 36px;
  border: 1px solid ${({ theme }) => theme.colors.light3};
  background-color: ${({ theme, isReadOnly }) =>
    isReadOnly ? theme.colors.light4 : theme.colors.light3};
  border-radius: ${theme.borderRadius}px;
  border-color: ${({ theme }) => theme.colors.light4};
  display: flex;
  justify-content: center;
  align-items: center;
`
